<template>
  <div class="editor-container">
    <!-- Intro Section -->
    <div class="intro-section">
      <div class="intro-icon">
        <svg preserveAspectRatio="none" width="70%" overflow="visible" style="display: block;" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V2H12V9L9.5 7.5L7 9V2H2V18Z" fill="#5587BC"/>
        </svg>
      </div>
      <p class="intro-text">
        <span class="intro-bold">Add Internal Notes</span> will create an internal note (staff only) for the patient.
      </p>
    </div>

    <!-- Properties Section -->
    <div class="properties-section">
      <!-- Info Banner -->
      <div class="info-banner">
        <div class="info-icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99984 0.666748C4.39984 0.666748 0.666504 4.40008 0.666504 9.00008C0.666504 13.6001 4.39984 17.3334 8.99984 17.3334C13.5998 17.3334 17.3332 13.6001 17.3332 9.00008C17.3332 4.40008 13.5998 0.666748 8.99984 0.666748ZM9.83317 13.1667H8.1665V8.16675H9.83317V13.1667ZM9.83317 6.50008H8.1665V4.83341H9.83317V6.50008Z" fill="#3498DB"/>
          </svg>
        </div>
        <p class="info-text">Internal notes are only visible to your practice staff.</p>
      </div>

      <!-- Add Internal Notes Field -->
      <div class="form-field">
        <Label label="Add Internal Notes" :required="true">
          <TextArea
            v-model="localData.notes"
            placeholder="Type your notes here"
            size="medium"
            @input="handleInput"
          />
        </Label>
      </div>

      <!-- Save Configuration Button -->
      <SaveConfigure
        :disabled="!isSaveActive"
        @save-configuration="handleSave"
      />
    </div>
  </div>
</template>

<script>
import SaveConfigure from '@/components/workflow/SaveConfigure.vue';

export default {
  name: 'ActionAddInternalNotesEditor',
  components: {
    SaveConfigure
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['save', 'close'],
  data() {
    return {
      localData: {
        notes: this.data.notes || ''
      }
    };
  },
  computed: {
    isSaveActive() {
      return Boolean(
        this.localData.notes &&
        this.localData.notes.trim().length > 0
      );
    }
  },
  watch: {
    'data.notes': {
      handler(newVal) {
        if (newVal !== this.localData.notes) {
          this.localData.notes = newVal || '';
        }
      }
    }
  },
  methods: {
    handleInput() {
      // Update the shared data instance directly
      this.data.notes = this.localData.notes;
    },
    handleSave() {
      const isValid = this.localData.notes && 
                     this.localData.notes.trim().length > 0;
      
      this.$emit('save', {
        notes: this.localData.notes,
        configured: isValid
      });
    }
  }
};
</script>

<style scoped>
.editor-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  background: #F9FBFD;
}

/* Intro Section */
.intro-section {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: #E4F3F5;
  border-radius: 5px;
}

.intro-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.intro-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #5587BC;
  margin: 0;
}

.intro-bold {
  font-weight: 700;
}

/* Properties Section */
.properties-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  overflow-y: auto;
  flex: 1;
}

/* Info Banner */
.info-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: #E8F4FD;
  border-radius: 8px;
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.info-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #333;
  margin: 0;
}

/* Form Field */
.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
</style>
